module.exports = __webpack_public_path__ + "static/media/hello_img_2.62b90953.png";